import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IncidentGeneralInfoComponent } from './incident-general-info/incident-general-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonCloudStudioModule } from 'common-cloudstudio';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { IncidentLocationRefComponent } from './incident-location-ref/incident-location-ref.component';
import { IncidentLanesComponent } from './incident-element-modal/Incident-lanes/Incident-lanes.component';
import { IncidentVehiclesInvolvedComponent } from './incident-element-modal/Incident-vehicles-involved/Incident-vehicles-involved.component';
import { IncidentPersonsComponent } from './incident-element-modal/incident-persons/incident-persons.component';
import { IncidentAttachmentsComponent } from './incident-element-modal/IncidentAttachments/IncidentAttachments.component';
import { IncidentElementModalComponent } from './incident-element-modal/incident-element-modal.component';
import { IncidentDamageRegisterComponent } from './incident-element-modal/incident-damage-register/incident-damage-register.component';
import { IncidentAssistencesComponent } from './incident-element-modal/incident-assistences/incident-assistances.component';
import { IncidentTablesComponent } from './incident-tables/incident-tables.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonCloudStudioModule,
    TooltipModule.forRoot(),
    SharedModule,
    BsDropdownModule,
  ],
  declarations: [
    IncidentGeneralInfoComponent,
    IncidentLocationRefComponent,
    IncidentLanesComponent, 
    IncidentVehiclesInvolvedComponent, 
    IncidentPersonsComponent,
    IncidentAttachmentsComponent,
    IncidentElementModalComponent,
    IncidentDamageRegisterComponent,
    IncidentAssistencesComponent,
    IncidentTablesComponent
  ],
  exports: [
    IncidentGeneralInfoComponent,
    IncidentLocationRefComponent,
    IncidentLanesComponent, 
    IncidentVehiclesInvolvedComponent, 
    IncidentPersonsComponent,
    IncidentAttachmentsComponent,
    IncidentElementModalComponent,
    IncidentDamageRegisterComponent,
    IncidentAssistencesComponent,
    IncidentTablesComponent
  ],
})
export class IncidentSharedModule {}
